import * as React from "react";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { LayoutGrid } from "lucide-react";
import { ComponentsPage } from "@/pages/components";

export const designSystemRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "components",
      handle: { title: "Components" },
      element: React.createElement(ComponentsPage),
    },
  ],
  shellRouteDefs: [
    {
      path: "/components",
      title: "Components",
      summary: "Every component and state in one place, in light and dark.",
    },
  ],
};

export const designSystemNav: FeatureNavModule = {
  navGroups: [
    {
      label: "Build",
      items: [{ to: "/components", label: "Components", icon: LayoutGrid, end: false }],
    },
  ],
};
